import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../hospital.css';
import '../../assets/css/mainstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // N'oublie pas d'importer les styles de toast
import api from '../../service/caller';
import Select from "react-select";
import Adminprofil from '../../assets/images/adminprofil.png';
import { getUserIdFromToken } from '../../utils/authUtils';

const Genaralconfig = () => {
    const [UserData, setUserData] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState("https://toppng.com/uploads/preview/icons-logos-emojis-user-icon-png-transparent-11563566676e32kbvynug.png");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewImage(URL.createObjectURL(file)); // Affichage de l'aperçu
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Veuillez sélectionner une image.");
            return;
        }

        const formData = new FormData();
        formData.append("logo", selectedFile); // Seule l'image est envoyée

        try {
            const response = await api.post("/api/addhospitallogo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            alert("Logo mis à jour avec succès !");
            setPreviewImage(`${api.defaults.baseURL}/${response.data.hospital.logo}`); // Mise à jour de l'affichage
        } catch (error) {
            console.error("Erreur :", error);
            alert(error.response?.data?.message || "Échec de l'envoi du fichier.");
        }
    };

    useEffect(() => {
        const fetchHospitals = async () => {
            if (!UserData || !UserData._id) return; // Assurez-vous que UserData est défini
    
            try {
                setLoading(true);
    
                const userId = UserData._id; // L'ID de l'utilisateur connecté
    
                const response = await api.post('/api/user-hospitals', { userId }); // Envoyer la requête POST avec l'ID de l'utilisateur
                setHospitals(response.data.hospitals);  // Mettre à jour l'état avec la liste des hôpitaux
                console.log('Hospitals:', response.data.hospitals);
                setError(null);
            } catch (err) {
                setError(err.response?.data?.message || 'Une erreur est survenue');
                console.error('Erreur:', err);
            } finally {
                setLoading(false);
            }
        };
    
        fetchHospitals();
    }, [UserData]); // Ajouter UserData comme dépendance pour que la requête se fasse à chaque changement de UserData
    

    const handleEditClick = (hospital) => {
        // Logique pour l'édition de l'hôpital
        console.log('Édition de l\'hôpital:', hospital);
        // Ici vous pouvez ouvrir une modal d'édition, ou rediriger vers une page d'édition
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (

        <div className="dashboard-header" >
            <ToastContainer />
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>General Config</b></h4>
                            <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Hospital Settings</span></p>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex ms-auto">
                                        <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2" style={{ color: 'black' }}>{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2" style={{ color: 'black' }}>{UserData.role?.name}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <section>
                <CRow>
                    <CCol xs={12}>
                        <CCard className="card mb-4 p-4">
                            <CCardBody>
                                <div className='d-flex'>
                                    <div>
                                        <div className="form-group newregistermodal">
                                            <div className="profile-photo d-flex">
                                                <div className="photo-container">
                                                    <img src={previewImage} alt="Profile" className="profile-image" />
                                                </div>
                                                <div className='photoedit'>
                                                    <label htmlFor="file-input">
                                                        <FaEdit />
                                                    </label>
                                                    <input type="file" id="file-input" accept="image/*" onChange={handleFileChange} />
                                                    <p className='ms-2'>Upload profile photo (jpg, png, jpeg)</p>
                                                </div>
                                            </div>
                                        </div>
                                        <button onClick={handleUpload} className="btn btn-primary mt-2">Upload Logo</button>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                                <div>
                                    <div className="hospitalListTable mt-5">
                                        <h4>Hospitals</h4>
                                        <CTable className="mt-2 ctable-no-border" align="middle" responsive>
                                            <CTableHead>
                                                <CTableRow className="tablehead">
                                                    <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">Currency</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">ACTION</CTableHeaderCell>
                                                </CTableRow>
                                            </CTableHead>
                                            <CTableBody>
                                                {hospitals.map((hospital) => (
                                                    <CTableRow className="ctable-row" key={hospital._id}>
                                                        <CTableDataCell align="middle">{hospital.hospital_spec_id}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_name}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_country}, {hospital.hospital_state_province}, {hospital.hospital_city}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_phone}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_currency}</CTableDataCell>
                                                        <CTableDataCell>
                                                            <div className="flex items-center space-x-4">
                                                                <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                                                                    <FaEllipsisV
                                                                        className="bg-none border-0 p-0"
                                                                        data-coreui-toggle="dropdown"
                                                                        aria-expanded="true"
                                                                        style={{ border: 'none', color: 'Green' }}
                                                                    />
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            {/* Action "Voir les détails" */}
                                                                            <a className="dropdown-item" href={`/hospital/${hospital._id}`}>
                                                                                <FaFolderOpen className="bg-none border-0 p-0" style={{ border: 'none' }} />
                                                                                View Details
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            {/* Action "Éditer" */}
                                                                            <CButton
                                                                                onClick={() => handleEditClick(hospital)}
                                                                                className="dropdown-item bg-none border-0"
                                                                                tabIndex={-1}
                                                                            >
                                                                                <FaEdit className="bg-none border-0 p-0" style={{ border: 'none' }} />
                                                                                Edit {hospital.name}
                                                                            </CButton>
                                                                        </li>
                                                                        <li>
                                                                            {/* Action "Télécharger" */}
                                                                            <a className="dropdown-item" href={`/hospitalcard/${hospital._id}`}>
                                                                                <FaDownload className="bg-none border-0 p-0" style={{ border: 'none' }} />
                                                                                Download
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </CTableDataCell>
                                                    </CTableRow>
                                                ))}
                                            </CTableBody>
                                        </CTable>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </section>

        </div >
    );
};

export default Genaralconfig;
